import React, { useState, useEffect } from 'react';
import { Menu, X, ExternalLink } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 100;
      setIsVisible(scrolled);
      setIsScrolled(scrolled);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  const handleDoorDashOrder = () => {
    window.open('https://www.doordash.com/store/hot-slice-pizza-seattle-34624387/74166152/', '_blank', 'noopener,noreferrer');
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 transform ${isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
      } ${isScrolled ? 'bg-gray-900/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'
      }`}>
      <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4">
        <nav className="flex items-center justify-between">
          <div className="flex items-center space-x-2 sm:space-x-3">
            <img
              src="/Hot%20Slice%20Pizza%20(1).png"
              alt="Hot Slice Pizza Logo"
              className="h-12 w-12 sm:h-16 sm:w-16 object-cover rounded-full"
            />
            <span className="text-base sm:text-2xl font-bold text-white font-pizza whitespace-nowrap">Hot Slice Pizza</span>
            <div className="bg-green-600 text-white px-2 py-1 rounded-full text-xs font-bold ml-2">
              HALAL
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-white hover:text-red-400 transition-colors duration-200 font-medium"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('menu')}
              className="text-white hover:text-red-400 transition-colors duration-200 font-medium"
            >
              Menu
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-white hover:text-red-400 transition-colors duration-200 font-medium"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('catering')}
              className="text-white hover:text-red-400 transition-colors duration-200 font-medium"
            >
              Catering
            </button>
            <button
              onClick={() => scrollToSection('gift-cards')}
              className="text-white hover:text-red-400 transition-colors duration-200 font-medium"
            >
              Gift Cards
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-white hover:text-red-400 transition-colors duration-200 font-medium"
            >
              Contact
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button
              className="text-white p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </nav>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden absolute top-full left-0 right-0 bg-gray-900/95 backdrop-blur-sm border-t border-gray-700">
            <div className="px-6 py-6">
              <button
                onClick={() => scrollToSection('home')}
                className="block w-full text-left text-white hover:text-red-400 hover:bg-gray-800/50 transition-all duration-200 font-medium py-3 px-4 rounded-lg mb-2"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('menu')}
                className="block w-full text-left text-white hover:text-red-400 hover:bg-gray-800/50 transition-all duration-200 font-medium py-3 px-4 rounded-lg mb-2"
              >
                Menu
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="block w-full text-left text-white hover:text-red-400 hover:bg-gray-800/50 transition-all duration-200 font-medium py-3 px-4 rounded-lg mb-2"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('catering')}
                className="block w-full text-left text-white hover:text-red-400 hover:bg-gray-800/50 transition-all duration-200 font-medium py-3 px-4 rounded-lg mb-2"
              >
                Catering
              </button>
              <button
                onClick={() => scrollToSection('gift-cards')}
                className="block w-full text-left text-white hover:text-red-400 hover:bg-gray-800/50 transition-all duration-200 font-medium py-3 px-4 rounded-lg mb-2"
              >
                Gift Cards
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="block w-full text-left text-white hover:text-red-400 hover:bg-gray-800/50 transition-all duration-200 font-medium py-3 px-4 rounded-lg"
              >
                Contact
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;